<template>
    <div id="frame-body" class="profile-content">
        <h1>{{ PROFILES.paletteSummary }}</h1>
        <div id="palette" class="flex layout-75-25 m-row">
            <div class="layout m-span">

                <!-- Usage -->
                <div class="section layout">
                    <h2>Overview</h2>
                    <div class="divider"></div>
                    <div class="flex layout-50 palette-lists row sub-section">
                        <div class="layout usage" v-for="(usage, u) in Usage(1)" :key="u">
                            <div class="item single">
                                <p class="name">{{ usage.Type }}</p>
                                <div class="bar">
                                    <div class="bar-value"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
    
                <!-- Palette -->
                <div class="layout section">
                    <h2>Palette</h2>
                    <div class="divider"></div>
                    <div class="flex layout-50 m-row row sub-section">
                        <div class="industry layout m-span" v-for="(detail, d) in Details()" :key="d">
                            <h3>{{ detail.industry }}</h3>
                            <div class="flex layout-50 palette-lists">
                                <List
                                    v-for="(list, l) in detail.columns"
                                    :key="l"
                                    :group="list.group"
                                    :items="list.list"
                                />
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <div class="layout m-span">
                <div class="section">
                    <div v-for="(itemType, i) of items" :key="i">
                        <h2>{{ itemType.type }}</h2>
                        <div class="divider"></div>
                        <div class="sub-section">
                            <div class="flex-y-center" v-for="(item, ii) in itemType.list" :key="ii">
                                <img class="margin-r" src="@/assets/Images/Check.png" alt="Icon - Check" title="Check" width="40" height="40"/>
                                <span>{{ item.Name }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Animation } from "@/assets/JS/Animation.js";
import { PROFILES } from "@/assets/JS/Assets.js";
import { profile } from "@/assets/JS/Config.js";
import { lists } from "@/assets/JS/Master.js";
import $ from "jquery";
import List from "@/components/Profile/PaletteSummary/List.vue";

export default {
    name: "ProfilePaletteSummary",
    props: { usageProfile: Object },
    components: { List },
    data: () => ({
        PROFILES,
        items: {}
    }),
    methods: {
        Usage: function(level) {
            const { Usage } = this.usageProfile;
            if (Usage) {
                return Usage.filter(u => u.Level === level && u.Type !== "");
            }
            return [];
        },
        Tools: function(industry) {
            const { Usage } = this.usageProfile;
            if (Usage) {
                return Usage.filter(u => u.Tool !== "" && u.Industry === industry);
            }
            return [];
        },
        Languages: function() {
            const { Usage } = this.usageProfile;
            if (Usage) {
                return Usage.filter(u => u.Language !== "");
            }
            return [];
        },
        Animate: function(group, usage, index) {
            new Animation(
                $($(`.${group} .bar-value`)[index]),
                "Width",
                `${usage.Percentile}%`,
                1000,
                profile.animationCascadeOffset * index
            );
        },
        Details: function() {
            return [
                {
                    industry: "Visual",
                    columns: [
                        {
                            group: "usage",
                            list: this.Usage(2)
                        },
                        {
                            group: "tools",
                            list: this.Tools("Visual")
                        }
                    ]
                },
                {
                    industry: "Functional",
                    columns: [
                        {
                            group: "languages",
                            list: this.Languages()
                        },
                        {
                            group: "tools",
                            list: this.Tools("Functional")
                        }
                    ]
                }
            ];
        }
    },
    mounted: function() {
        const { Usage, PaletteItems } = this.usageProfile;

        if (Usage) {
            let t, tt, l;
            t = tt = l = -1;
            for (const usage of Usage) {
                const { Type, Tool, Language } = usage;
                if (Type !== "") {
                    t++;
                    this.Animate("usage", usage, t);
                }
                if (Tool !== "") {
                    tt++;
                    this.Animate("tools", usage, tt);
                }
                if (Language !== "") {
                    l++;
                    this.Animate("languages", usage, l);
                }
            }
        }

        // Set items by type
        if (PaletteItems) {
            const types = [];
            for (const item of PaletteItems) {
                types.push(item.Type);
            }
            const uniqueTypes = types.filter(lists.Unique);
            let i = -1;
            for (const uniqueType of uniqueTypes) {
                i++;
                this.items[i] = {
                    type: uniqueType,
                    list: PaletteItems.filter(pi => pi.Type === uniqueType)
                };
            }
        }

    }
};
</script>